const globalModalsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'TOGGLE_MODALS':
            return {
                ...state,
                ...action.payload
            }
        default:
            return state
    }
}

export default globalModalsReducer